var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tab-pane",
    { staticClass: "no-padding", attrs: { name: "expenses" } },
    [
      _c(
        "div",
        { staticClass: "layout-padding" },
        [
          _vm.hasExpenses
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "row gutter-sm q-mt-sm" },
                  [_c("expense-list", { attrs: { expenses: _vm.expenses } })],
                  1
                )
              ])
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "row justify-center items-center col-grow q-pt-lg"
                  },
                  [
                    _c("div", { staticClass: "text-center" }, [
                      _c("img", {
                        attrs: {
                          src: require("assets/emptystates/expenses_empty.svg"),
                          width: "40%"
                        }
                      }),
                      _c("h6", { staticClass: "q-my-md text-faded" }, [
                        _vm._v(_vm._s(_vm.$t("no_expenses")))
                      ])
                    ])
                  ]
                )
              ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }